/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessEntityListResult } from '../models/BusinessEntityListResult';
import type { CertifyLicensingAgencyRequest } from '../models/CertifyLicensingAgencyRequest';
import type { CreateLicensingAgencyRequest } from '../models/CreateLicensingAgencyRequest';
import type { CreateLicensingAgencyResult } from '../models/CreateLicensingAgencyResult';
import type { CreateLicensingAgencyUserRequest } from '../models/CreateLicensingAgencyUserRequest';
import type { CreateLicensingAgencyUserResult } from '../models/CreateLicensingAgencyUserResult';
import type { ExportFormat } from '../models/ExportFormat';
import type { GetLicensingAgencyHistoryResponse } from '../models/GetLicensingAgencyHistoryResponse';
import type { GetLicensingAgencyUserResult } from '../models/GetLicensingAgencyUserResult';
import type { LicensingAgency } from '../models/LicensingAgency';
import type { LicensingAgencyDocumentType } from '../models/LicensingAgencyDocumentType';
import type { LicensingAgencySort } from '../models/LicensingAgencySort';
import type { LicensingAgencyStatus } from '../models/LicensingAgencyStatus';
import type { ListLicensingAgenciesResult } from '../models/ListLicensingAgenciesResult';
import type { ListLicensingAgencyUsersResult } from '../models/ListLicensingAgencyUsersResult';
import type { MccsRoles } from '../models/MccsRoles';
import type { SortDirection } from '../models/SortDirection';
import type { StoredDocument } from '../models/StoredDocument';
import type { UpdateLicensingAgencyRequest } from '../models/UpdateLicensingAgencyRequest';
import type { UpdateLicensingAgencyUserRequest } from '../models/UpdateLicensingAgencyUserRequest';
import type { UserSort } from '../models/UserSort';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LicensingAgenciesService {
  /**
   * Create a new licensing agency with the specified details
   * @param requestBody
   * @returns CreateLicensingAgencyResult Created
   * @throws ApiError
   */
  public static create(
    requestBody?: CreateLicensingAgencyRequest,
  ): CancelablePromise<CreateLicensingAgencyResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/LicensingAgencies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * List all licensing agencies with optional filtering criteria
   * @param query
   * @param status
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns ListLicensingAgenciesResult OK
   * @throws ApiError
   */
  public static list(
    query?: string,
    status?: Array<LicensingAgencyStatus>,
    limit?: number,
    offset?: number,
    sortBy?: LicensingAgencySort,
    sortDirection?: SortDirection,
  ): CancelablePromise<ListLicensingAgenciesResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies',
      query: {
        'query': query,
        'status': status,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a specific licensing agency by ID
   * @param licensingAgencyId
   * @returns LicensingAgency OK
   * @throws ApiError
   */
  public static get(
    licensingAgencyId: string,
  ): CancelablePromise<LicensingAgency> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update one or more fields for a business entity.
   * @param licensingAgencyId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static update(
    licensingAgencyId: string,
    requestBody?: UpdateLicensingAgencyRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/LicensingAgencies/{licensingAgencyId}',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get the tax ID of a specific licensing agency by ID
   * @param licensingAgencyId
   * @returns string OK
   * @throws ApiError
   */
  public static getTaxId(
    licensingAgencyId: string,
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/tax-id',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Certify a licensing agency application with the certifier's title. The authorized user is recorded as the certifier, along with today's date.
   * @param licensingAgencyId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static certify(
    licensingAgencyId: string,
    requestBody?: CertifyLicensingAgencyRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/LicensingAgencies/{licensingAgencyId}/certify',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Approve a licensing agency application. This can only be done after the application has been submitted.
   * @param licensingAgencyId
   * @returns void
   * @throws ApiError
   */
  public static approve(
    licensingAgencyId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/LicensingAgencies/{licensingAgencyId}/approve',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
    });
  }
  /**
   * Reject a licensing agency application. This can only be done after the application has been submitted.
   * @param licensingAgencyId
   * @returns void
   * @throws ApiError
   */
  public static reject(
    licensingAgencyId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/LicensingAgencies/{licensingAgencyId}/reject',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
    });
  }
  /**
   * List business entities (companies) the licensing agency is authorized to view/manage.
   * @param licensingAgencyId
   * @param query
   * @returns BusinessEntityListResult OK
   * @throws ApiError
   */
  public static listBusinessEntities(
    licensingAgencyId: string,
    query?: string,
  ): CancelablePromise<BusinessEntityListResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/business-entities',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      query: {
        'query': query,
      },
    });
  }
  /**
   * Get the change history for a licensing agency by its id.
   * @param licensingAgencyId
   * @returns GetLicensingAgencyHistoryResponse OK
   * @throws ApiError
   */
  public static getHistory(
    licensingAgencyId: string,
  ): CancelablePromise<GetLicensingAgencyHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/history',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
    });
  }
  /**
   * Create a user for a specific licensing agency. This will find or create the user, and grant them the requested role(s) on the licensing agency.
   * @param licensingAgencyId
   * @param requestBody
   * @returns CreateLicensingAgencyUserResult Created
   * @throws ApiError
   */
  public static createUser(
    licensingAgencyId: string,
    requestBody?: CreateLicensingAgencyUserRequest,
  ): CancelablePromise<CreateLicensingAgencyUserResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/LicensingAgencies/{licensingAgencyId}/users',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * List users for a specific licensing agency.
   * @param licensingAgencyId
   * @param query
   * @param role
   * @param enabled
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListLicensingAgencyUsersResult OK
   * @throws ApiError
   */
  public static listUsers(
    licensingAgencyId: string,
    query?: string,
    role?: Array<MccsRoles>,
    enabled?: boolean,
    limit?: number,
    offset?: number,
    sortBy?: UserSort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListLicensingAgencyUsersResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/users',
      path: {
        'licensingAgencyId': licensingAgencyId,
      },
      query: {
        'query': query,
        'role': role,
        'enabled': enabled,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Get a specific user for a licensing agency.
   * @param licensingAgencyId
   * @param userId
   * @returns GetLicensingAgencyUserResult OK
   * @throws ApiError
   */
  public static getUser(
    licensingAgencyId: string,
    userId: string,
  ): CancelablePromise<GetLicensingAgencyUserResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/users/{userId}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'userId': userId,
      },
    });
  }
  /**
   * Update a licensing agency user by their unique identifier.
   * @param licensingAgencyId
   * @param userId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateUser(
    licensingAgencyId: string,
    userId: string,
    requestBody?: UpdateLicensingAgencyUserRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/LicensingAgencies/{licensingAgencyId}/users/{userId}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Remove a user from a specific licensing agency. This does not delete the user, only removes their association with the licensing agency.
   * @param licensingAgencyId
   * @param userId
   * @returns void
   * @throws ApiError
   */
  public static removeUser(
    licensingAgencyId: string,
    userId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/LicensingAgencies/{licensingAgencyId}/users/{userId}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'userId': userId,
      },
    });
  }
  /**
   * Upload a licensing agency document to S3.
   * @param licensingAgencyId
   * @param documentType
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadLicensingAgencyDocument(
    licensingAgencyId: string,
    documentType: LicensingAgencyDocumentType,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/LicensingAgencies/{licensingAgencyId}/uploads/{documentType}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'documentType': documentType,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Get licensing agency document metadata, if one exists, for a document type.
   * @param licensingAgencyId
   * @param documentType
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getLicensingAgencyDocument(
    licensingAgencyId: string,
    documentType: LicensingAgencyDocumentType,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/uploads/{documentType}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a licensing agency document for a document type.
   * @param licensingAgencyId
   * @param documentType
   * @returns void
   * @throws ApiError
   */
  public static deleteLicensingAgencyDocument(
    licensingAgencyId: string,
    documentType: LicensingAgencyDocumentType,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/LicensingAgencies/{licensingAgencyId}/uploads/{documentType}',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stream a licensing agency document for preview or download.
   * @param licensingAgencyId
   * @param documentType
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadLicensingAgencyDocument(
    licensingAgencyId: string,
    documentType: LicensingAgencyDocumentType,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/LicensingAgencies/{licensingAgencyId}/uploads/{documentType}/content',
      path: {
        'licensingAgencyId': licensingAgencyId,
        'documentType': documentType,
      },
      query: {
        'download': download,
      },
    });
  }
}
